import { getErrorCode } from '@/lib/error-utils';

// Backend codes that mean "ask for the current password", mapped to what the
// field says. Any other code is a generic failure shown above the form. Kept
// here rather than in the account page because every password surface talks to
// the same endpoints, and a second copy of this wording would drift from it.
export const OLD_PASSWORD_ERRORS: Record<string, string> = {
  CURRENT_PASSWORD_REQUIRED: 'Enter your current password to change it',
  INVALID_CREDENTIALS: 'That current password is not correct',
};

export type OtpBlockReason = 'lock' | 'user' | 'ip';

const OTP_BLOCK_REASONS = new Map<string | undefined, OtpBlockReason>([
  ['OTP_LOCKED', 'lock'],
  ['OTP_RATE_LIMITED', 'user'],
  ['TOO_MANY_REQUESTS', 'ip'],
]);

// Sorted by code and timed by the server only. Matching "too many" in the
// message put a wrong-code lock under a guessed 15-minute rate-limit
// countdown. Without a server time there is nothing to count down from, so the
// caller shows the backend's own sentence instead.
export const otpBlockOf = (
  error: unknown
): { reason: OtpBlockReason; retryAfterMs: number } | null => {
  const reason = OTP_BLOCK_REASONS.get(getErrorCode(error));
  const seconds = (
    error as { details?: { retry_after_seconds?: unknown } } | null
  )?.details?.retry_after_seconds;
  if (!reason || typeof seconds !== 'number' || !(seconds > 0)) return null;
  return { reason, retryAfterMs: seconds * 1000 };
};

// The lock line opens with the backend's own lock sentence, which the code
// step and the signup screens show as sent, so one lock reads the same
// everywhere.
export const OTP_BLOCK_COPY: Record<OtpBlockReason, string> = {
  lock: 'Your account is temporarily locked after too many wrong codes. You can try again in',
  user: 'Too many attempts. You can try again in',
  ip: 'Too many attempts. You can try again in',
};
